import { useState, useEffect } from "react"
import { useHistory } from "react-router"
import { useSelector, PromiseDispatch } from "../store"
import { useDispatch } from "react-redux"
import { loginWithToken } from "../store/user/actions"
import { SetRedirection } from "../store/redirection/action"

export function useLogin(
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
) {
  const { isLoggedIn, token } = useSelector(
    ({ user: { isLoggedIn, token } }) => ({
      isLoggedIn,
      token,
    }),
  )
  const promiseDispatch = useDispatch<PromiseDispatch<void>>()
  const dispatch = useDispatch()
  const history = useHistory()
  const [path] = useState(history.location.pathname)

  useEffect(() => {
    if (!isLoggedIn) {
      if (token) {
        promiseDispatch(loginWithToken())
          .then(() => {
            if (history.location.pathname === "/login") {
              history.replace(path && path !== "/login" ? path : "/")
            }
            setLoading(false)
          })
          .catch(() => {
            if (history.location.pathname === "/login") {
              history.replace(path && path !== "/login" ? path : "/")
            }
            setLoading(false)
          })
      } else {
        dispatch(SetRedirection(path))
        setLoading(false)
      }
    } else {
      setLoading(false)
    }
  }, [])
}
